import Service from "@/services";

export default {
    namespaced: true,
    state: {
        plans: [],
        anonymousEnabled: false,
        gemRate: null,
    },
    getters: {
        plans: (state) => state.plans,
        anonymousEnabled: (state) => state.anonymousEnabled,
        gemRate: (state) => state.gemRate,
    },
    actions: {
        async getGiftingPlans({ commit }) {
            try {
                const res = await Service().get("../api/gifting/plans");
                const plans = res?.data?.plans ?? [];

                commit("SET_PLANS", plans);
                commit("SET_ANONYMOUS_ENABLED", !!res?.data?.enabled);

                return plans.length > 0;
            } catch (e) {
                console.error("Error fetching gifting plans:", e);
                commit("SET_PLANS", []);

                return e;
            }
        },
        // eslint-disable-next-line no-unused-vars
        async getGiftingBalance({ commit }) {
            try {
                return await Service().get("../api/gifting/balance");
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error fetching balance:", e);
                return null;
            }
        },
        // eslint-disable-next-line no-unused-vars
        async convertToGems({ commit }, payload) {
            try {
                return await Service().post("../api/gifting/convert", payload);
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error converting to gems:", e);
                return null;
            }
        },
        async getGemRate({ commit }) {
            try {
                const res = await Service().get("../api/gifting/gem-rate");
                const rate = res?.data ?? null;

                commit("SET_GEM_RATE", rate);

                return rate;
            } catch (e) {
                console.error("Error fetching gem rate:", e);
                commit("SET_GEM_RATE", null);

                return null;
            }
        },
        // eslint-disable-next-line no-unused-vars
        async startGiftingCheckout({ commit }, payload) {
            try {
                return await Service().post("../api/gifting/checkout", payload);
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error starting gifting checkout:", e);
                return [];
            }
        },
        // eslint-disable-next-line no-unused-vars
        async verifyGiftingCheckout({ commit }, payload) {
            try {
                return await Service().post("../api/gifting/verify", payload);
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error verifying gifting payment:", e);
                return null;
            }
        },
        // eslint-disable-next-line no-unused-vars
        async getGiftingSubscription({ commit }) {
            try {
                return await Service().get("../api/gifting/subscription");
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error reading gifting subscription:", e);
                return null;
            }
        },
        // eslint-disable-next-line no-unused-vars
        async getGiftingTransactions({ commit }, payload) {
            try {
                return await Service().get("../api/gifting/transactions", {
                    params: payload,
                });
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error reading gifting transactions:", e);
                return null;
            }
        },
        // eslint-disable-next-line no-unused-vars
        async resumeGiftingSubscription({ commit }) {
            try {
                return await Service().post(
                    "../api/gifting/subscription/resume"
                );
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error resuming gifting subscription:", e);
                return null;
            }
        },
        // eslint-disable-next-line no-unused-vars
        async cancelGiftingSubscription({ commit }) {
            try {
                return await Service().post(
                    "../api/gifting/subscription/cancel"
                );
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error("Error cancelling gifting subscription:", e);
                return null;
            }
        },
    },
    mutations: {
        SET_PLANS: (state, payload) => (state.plans = payload),
        SET_ANONYMOUS_ENABLED: (state, payload) => (state.anonymousEnabled = payload),
        SET_GEM_RATE: (state, payload) => (state.gemRate = payload),
    },
};
